(function autoCloseDetails() {
  // window.innerWidth forces a layout read. It used to be read once per matched
  // element, inside a click handler that runs on every tap on the page — including
  // add-to-cart. Read it once per click instead.
  document.addEventListener('click', function (event) {
    const openDetails = document.querySelectorAll('details[data-auto-close-details][open]');
    if (openDetails.length === 0) return;

    const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
    const detailsToClose = [...openDetails].filter(
      (element) => {
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();
